import React from 'react';
import { Link } from 'react-router-dom';
import { Wordmark } from '../brand/Wordmark';
import { footerGroups } from '../../data/navigation';
import { useLanguage } from '../../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="border-t mf-hairline bg-[#050F1C]" data-id="element-300" data-mp="5n2onnfs2o94">
      <div className="mx-auto max-w-site px-5 py-16 md:px-8" data-id="element-301" data-mp="5mkju2f1v1pl">
        <div className="grid gap-12 lg:grid-cols-[1.3fr_repeat(4,1fr)]" data-id="element-302" data-mp="oiz7d1z6uc0">
          <div data-id="element-303" data-mp="3s2nhlykz9822">
            <Wordmark data-id="element-304" data-mp="3s25bma8ijfgy" />
            <p className="mt-5 max-w-xs font-display text-lg uppercase tracking-[0.06em] text-titanium" data-id="element-305" data-mp="3s1m29hwxhzej">
              Professional-Grade Lighting. Built for the Elements.
            </p>
            <p className="mt-3 text-sm text-titanium/70" data-id="element-306" data-mp="3j2s1rggh8ovp">{t('footer.tagline')}</p>
          </div>
          {footerGroups.map(g => <nav key={g.title} aria-label={g.title} data-id="element-307" data-mp="3e249yskfc40f">
              <h2 className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-white" data-id="element-308" data-mp="3939kj7rybh7c">{g.title}</h2>
              <ul className="mt-4 space-y-2.5" data-id="element-309" data-mp="2kc1vol4rtdvv">
                {g.links.map(l => <li key={l.to} data-id="element-310" data-mp="2p433nuuwoig3">
                    <Link to={l.to} className="text-sm text-titanium transition-colors duration-150 hover:text-white" data-id="element-311" data-mp="2p54h25ze9h0z">
                      {l.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>)}
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t mf-hairline pt-6 text-xs leading-relaxed text-titanium/60 md:flex-row md:justify-between" data-id="element-312" data-mp="342f3gadks7bh">
          <p data-id="element-313" data-mp="2u2wj3str6jiw">© {new Date().getFullYear()} MarineForceLED. All rights reserved.</p>
          <p className="max-w-2xl md:text-right" data-id="element-314" data-mp="2u50lu7fx1chl">
            Specifications are manufacturer-advertised; actual performance varies with conditions and use. Purchases are
            subject to our Terms of Service, including binding individual arbitration. Warranty coverage is subject to the
            terms on our Warranty page.
          </p>
        </div>
      </div>
    </footer>;
}